module.exports = __webpack_public_path__ + "media/images/drag_handle-8def1a38df08e63774ae9390063f81e9.png";